var exports = {
  "kL": "x31de4314--dfcca3--container",
  "VO": "x31de4314--dfcca3--full-width",
  "p_": "x31de4314--dfcca3--list",
};

module.exports = exports;
